import { DrawerComponent } from '@theme/drawer-component';

class PdpSizeGuide extends DrawerComponent {
  #isPortaling = false;

  connectedCallback() {
    if (this.parentElement !== document.body) {
      this.#isPortaling = true;
      this.dataset.portaling = '';
      document.body.appendChild(this);
      delete this.dataset.portaling;
      this.#isPortaling = false;
    }

    super.connectedCallback();
  }
}

if (!customElements.get('pdp-size-guide')) {
  customElements.define('pdp-size-guide', PdpSizeGuide);
}
